module.exports = __webpack_public_path__ + "media/images/twitter-7d3ce95633b160656b6a195c2786c2df.png";